export interface IBreakdownSummary {
  count: number;
  totalInCents: number;
}

/**
 * Totals a price-breakdown section for its collapsed header summary.
 */
export function summariseBreakdown(
  rows: { amount?: number }[]
): IBreakdownSummary {
  return {
    count: rows.length,
    totalInCents: rows.reduce((sum, row) => sum + (row.amount || 0), 0),
  };
}
